import { render, staticRenderFns } from "./BotonesProcesoCapacitacion.vue?vue&type=template&id=3fa13211&"
import script from "./BotonesProcesoCapacitacion.vue?vue&type=script&lang=js&"
export * from "./BotonesProcesoCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports